import React from 'react';
import { Typography, Paper, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/auth/AuthProvider';

const Settings: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const roles: string[] = user?.roles || [];
  const isSuperAdmin = roles.includes('super_admin');
  return (
    <div className="space-y-6">
      <div>
        <Typography variant="h4" className="font-bold text-gray-900 mb-2">
          Settings
        </Typography>
        <Typography variant="body1" className="text-gray-600">
          Configure your account and application preferences
        </Typography>
      </div>

      <Paper className="p-6 shadow-card">
        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between" spacing={2}>
          <div>
            <Typography variant="h6" className="font-semibold mb-1">
              User Management (Admins)
            </Typography>
            <Typography variant="body2" className="text-gray-600">
              Manage user roles and approval settings.
            </Typography>
          </div>
          <Button variant="contained" onClick={() => navigate('/settings/users')}>
            Open Users Management
          </Button>
        </Stack>
      </Paper>
      {isSuperAdmin && (
        <Paper className="p-6 shadow-card">
          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between" spacing={2}>
            <div>
              <Typography variant="h6" className="font-semibold mb-1">
                Categories Management (Super Admin)
              </Typography>
              <Typography variant="body2" className="text-gray-600">
                Manage expense categories, codes, and policy limits.
              </Typography>
            </div>
            <Button variant="contained" onClick={() => navigate('/settings/categories')}>
              Open Categories Management
            </Button>
          </Stack>
        </Paper>
      )}
      
    </div>
  );
};

export default Settings;
